import { CustomValidation } from './CustomValidation';
import { Attribute } from './Attribute';
import { ControlLayout } from '../Enums/ControlLayout';
import { FileType } from '../Enums/FileType';
import { FileDTO } from './FileDTO';

export class FileOptions {
    /**
 * Represent Name Of Form Control
 */
Name:string
/**
*   Represent classes to FileInput that allow us to select the FileInput by jquery or javascript 
*/

ExtraClasses:string

/**  Represent value of the label*/
LabelValue:string
 /**  Represent Key of the label*/
 LabelKey:string
/**  Represent value of the labelDescription show under FileInput*/
LabelDescription:string
/**To set  value  to FileInput */
Value:FileDTO[]
/**
  * Display "*" beside the label 
  * if ForceAsterisk=true and IsRequired=True his display "*" ,
  * if if ForceAsterisk=false and IsRequired=false this remove "*",
  *if ForceAsterisk=false and IsRequired=True this display "*" , 
   */ 
  ShowAsterisk: boolean
  /** Ability to set  FileInput required */
  IsRequired: boolean
  /** Ability to set  FileInput required */
  IsMultipleFile: boolean=false
  /** Ability to display or hide the label of FileInput */
  HideLabel:  boolean
  /** Sets an attribute disable="disabled"  */
  IsDisabled: boolean
   /** Sets  boolean Value to Show IsDropZone Or Not   */
   IsDropZone: boolean=false
  /** Allow to Pass Object With Body of Function which represent CustomValidation and massage for error massage 
  */
 CustomValidation: CustomValidation[]=[]
 /** Set List of Custom Attribute to FileInput  */
  AttributeList:Attribute[]
  /** Set File MaxSize In MB  */
  FileMaxSizeInMB: number;  
  /** Set Max Number Of Files  */
  MaxNoOfFiles: number;
  /** Set Min Number Of Files  */
  MinNoOfFiles: number;
   /** Set File MaxSizeForAllFilesInMB In MB  */
  MaxSizeForAllFilesInMB: number;
  /**  to set type of view  if textbox is Vertical or Horizontal */
  ViewType:ControlLayout=ControlLayout.Vertical
   /** Set List of Custom Attribute to FileInput  */
   FileUploadAcceptsTypes:FileType[]
  }
  